import { useState, useCallback, useRef } from "react";
import { toast } from "react-toastify";
import { OrderFilters, PaginationData } from "../types/order";
import { getDateRange } from "../utils/dateUtils";
import { Order } from "src/shared/services/interfacev2";
import api from "src/features/auth/axiosConfig";

export const useOrders = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState<PaginationData>({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  });

  const requestInProgress = useRef(false);

  const lastFilters = useRef<OrderFilters | null>(null);
  const lastPage = useRef<number | null>(null);
  const lastPageSize = useRef<number | null>(null);

  const fetchOrders = useCallback(async (pageNumber: number, pageSize: number, filters: OrderFilters) => {
    const sameFilters = JSON.stringify(filters) === JSON.stringify(lastFilters.current);
    const samePage = pageNumber === lastPage.current;
    const sameSize = pageSize === lastPageSize.current;

    if (sameFilters && samePage && sameSize) {
      console.error("⛔ Skipped! Same filter & pagination — no API call.");
      return;
    }

    // Save new filter state
    lastFilters.current = filters;
    lastPage.current = pageNumber;
    lastPageSize.current = pageSize;

    if (requestInProgress.current) return;
    requestInProgress.current = true;

    try {
      setLoading(true);

      const { from, to } = getDateRange(filters.timeRange || "Today", filters.customStartDate, filters.customEndDate);

      const url = `/app/pos/v2/order?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFilter=custom&startDate=${from}&endDate=${to}&searchBy=${filters.searchTerm || ""}&staffId=${
        filters.selectedStaff || ""
      }`;

      // const response = await getOrder(
      //   "", // id
      //   pageNumber,
      //   pageSize,
      //   from,
      //   to,
      //   "", // customer name
      //   filters.selectedStaff || "", // staffId
      //   "", // sortField
      //   "", // status
      //   { searchBy: filters.searchTerm || "" }
      // );

      // if (!response?.data?.result) return;

      // // ✅ FRONTEND STAFF FILTER (TEMP FIX)
      // const filteredOrders = filters.selectedStaff
      //   ? response.data.result.filter((item: Order) => item.orders?.some((o: any) => o.staffDetails?.staffId === filters.selectedStaff))
      //   : response.data.result;

      // // ✅ SET ONLY ONCE
      // setOrders(filteredOrders);

      const response = await api.get(url);

      if (response.data && response.data.result) {
        setOrders(response.data.result);
        setPaginationData({
          totalRecords: response.data.totalRecords || 0,
          totalPages: response.data.totalPages || 0,
          currentPage: response.data.currentPage || 1,
          pageSize: response.data.pageSize || 10,
        });
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Failed to fetch orders");
    } finally {
      setLoading(false);
      requestInProgress.current = false;
    }
  }, []);

  return { orders, loading, paginationData, fetchOrders };
};
